// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const zh_cn_pmaintitle2 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `Steeze UI 图标可视化 - ${i.name}`
};

const en_pmaintitle2 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `Steeze UI Icons View - ${i.name}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ name: NonNullable<unknown> }} inputs
* @param {{ locale?: "zh-cn" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const pmaintitle2 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pmaintitle2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pmaintitle2", locale)
	if (locale === "zh-cn") return zh_cn_pmaintitle2(inputs)
	if (locale === "en") return en_pmaintitle2(inputs)
	return "pMainTitle"
};
export { pmaintitle2 as "pMainTitle" }